/**
 * Design-Dokumente (CouchDB-View-Definitionen) fuer bpweb — SINGLE SOURCE OF TRUTH.
 *
 * Genutzt an zwei Stellen, damit die Definition NUR hier steht:
 *  - Gateway-Modus (dev-new / prod-neu): ProjectService.registerDesignDocs()
 *    schickt sie an `PUT /db/admin/design/bpweb`; die luzula-api installiert sie
 *    mit ADMIN-Credentials — der `bpweb-writer`-Service-Account ist bloss Member
 *    und darf `_design/*`-Docs nicht schreiben.
 *  - Legacy-Modus (Direktverbindung mit Admin-Creds in der URL): ProjectService
 *    schreibt sie in initDesignDocs() selbst.
 *
 * Aendern sich die Views, aendert sich NUR diese Datei — KEIN luzula-api-Deploy
 * noetig: die API ist generisch und nimmt entgegen, was die App registriert.
 *
 * **Die Sicht ist eine Auswahl, kein ganzes Dokument** (22.09.2026): Was hier
 * nicht emittiert wird, kennt die Projektliste nicht — egal, was am Dokument
 * steht. Genau daran scheiterte die Spalte „Letzte Änderung": Der Stempel
 * `zuletztGearbeitet` und die Spur `luzula` (wer hat das Projekt zuletzt
 * bearbeitet) lagen am Dokument und kamen nie in der Liste an. Wer ein neues
 * Feld in der Projektliste braucht, muss es hier UND in
 * `ProjectService.refreshProjectList` durchreichen.
 */
export const BPWEB_DESIGN_DOCS = [
	{
		_id: '_design/app_views',
		views: {
			by_id: {
				map: `function(doc) { emit(doc._id, { name: doc.name, description: doc.description, owner: doc.owner, bearbeiter: doc.bearbeiter, kontrolleure: doc.kontrolleure, archived: doc.archived, groups: doc.groups, luzula: doc.luzula, zuletztGearbeitet: doc.zuletztGearbeitet, workflow: doc.workflow ? { status: doc.workflow.status, lastStatusChange: doc.workflow.lastStatusChange, finalizedAt: doc.workflow.finalizedAt } : undefined });}`
			},
			by_member: {
				map: `function(doc) {
					var value = { _id: doc._id, name: doc.name, description: doc.description, owner: doc.owner, bearbeiter: doc.bearbeiter, kontrolleure: doc.kontrolleure, archived: doc.archived, groups: doc.groups, luzula: doc.luzula, zuletztGearbeitet: doc.zuletztGearbeitet, workflow: doc.workflow ? { status: doc.workflow.status, lastStatusChange: doc.workflow.lastStatusChange, finalizedAt: doc.workflow.finalizedAt } : undefined };
					if (doc.owner && doc.owner.id) {
						emit(doc.owner.id, value);
					}
					if (doc.bearbeiter && Array.isArray(doc.bearbeiter)) {
						doc.bearbeiter.forEach(function(k) {
							if (k.id) emit(k.id, value);
						});
					}
					if (doc.kontrolleure && Array.isArray(doc.kontrolleure)) {
						doc.kontrolleure.forEach(function(k) {
							if (k.id) emit(k.id, value);
						});
					}
				}`
			},
			by_invite: {
				map: `function(doc) {
					if (doc.pendingInvites && Array.isArray(doc.pendingInvites)) {
						var value = { _id: doc._id, name: doc.name, description: doc.description, owner: doc.owner, groups: doc.groups, pendingInvites: doc.pendingInvites };
						doc.pendingInvites.forEach(function(inv) {
							if (inv && inv.email) emit(String(inv.email).toLowerCase(), value);
							if (inv && inv.username) emit(String(inv.username).toLowerCase(), value);
						});
					}
				}`
			}
		}
	}
];
